import React from 'react';

import { DiskButton } from 'apps/auth/components/common/DiskButton/DiskButton';
import { useExtra } from 'apps/auth/hooks/selectors';

import { Container } from './styles';
import BaseLayout from '../BaseLayout';
import { MainColumn } from '../MainColumn/MainColumn';
import { NavBar } from '../NavBar/NavBar';
import { StubPage } from '../StubPage';

interface CommonPageProps {
    showPromoBanner?: boolean;
    backUrl?: string;
    leftCloseIcon?: boolean;
    rightHeaderComponent?: React.ReactNode;
    hasBottomPanel?: boolean;
    onClickIcon?: React.MouseEventHandler<HTMLButtonElement>;
    isTagA?: boolean;
    isBackButton?: boolean;
    stateOptions?: { isGA?: boolean };
    children?: React.ReactNode;
}

type CommonPageExtra = {
    gaServerNotAvailable?: boolean;
};

const getNavBarAlign = (props: CommonPageProps): 'left' | 'right' | 'space-between' => {
    if (props.rightHeaderComponent && props.backUrl) {
        return 'space-between';
    }
    if (props.backUrl || props.isBackButton) {
        return 'left';
    }
    return 'right';
};

export const CommonPage: React.FC<CommonPageProps> = (props) => {
    const { gaServerNotAvailable } = useExtra<CommonPageExtra>() ?? {};

    const renderContent = () => {
        if (gaServerNotAvailable && props?.stateOptions?.isGA) {
            return (
                <MainColumn>
                    <StubPage />
                </MainColumn>
            );
        }
        return props.children;
    };

    return (
        <BaseLayout showPromoBanner={props.showPromoBanner}>
            <Container hasBottomPanel={props.hasBottomPanel}>{renderContent()}</Container>
            {(props.backUrl || props.rightHeaderComponent || props.isBackButton) && (
                <NavBar align={getNavBarAlign(props)}>
                    {(props.backUrl || props.isBackButton) && (
                        <DiskButton
                            type={props.isTagA ? 'tagA' : props.isBackButton ? 'button' : undefined}
                            to={props.backUrl}
                            href={props.backUrl}
                            onClick={props.onClickIcon}
                            iconName={props.leftCloseIcon ? 'cross' : 'arrow-back'}
                        />
                    )}
                    {props.rightHeaderComponent}
                </NavBar>
            )}
        </BaseLayout>
    );
};
